import { Component, OnInit } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';
import { BcAccountClientService } from '../../service/bc-account-client.service';

@Component({
  selector: 'app-bc-allowance-modal',
  templateUrl: './bc-allowance-modal.component.html',
  styleUrls: ['./bc-allowance-modal.component.scss'],
  providers: [BcAccountClientService]
})

export class BcAllowanceModalComponent extends DialogComponent<BcAllowanceModalComponent, boolean> implements OnInit {

  title: string;
  selectedBillings: any[] = [];
  contaClienteID: string;

  private isAuto = false;
  private reasonList = [];
  private selectedReason;
  private errorMessage;

	  constructor(dialogService: DialogService, private bcAccountClientService: BcAccountClientService) {
		super(dialogService);
  }

  allowAuto(){

    let titlesObj = [];

    this.selectedBillings.forEach(title => {
      titlesObj.push({
        NumeroDocumento: title.NumeroDocumento,
        Linha: title.Linha,
        AnoExercicio: title.AnoExercicio,
        Empresa: title.Empresa,
        ValorDocumento: title.ValorInterno
      });
    });

    const allowanceAutoObj = {
      Motivo: this.selectedReason,
      Titulos: titlesObj,
      ContaClienteID: this.contaClienteID
    }

    this.bcAccountClientService.allowAuto(allowanceAutoObj).subscribe(result => {
			if (result.Success) {
        this.result = true;
        this.close();
			} else {
				this.errorMessage = result.Errors;
			}
		}, error => {
			console.log(error);
		});
  }

  sendToProposal(){

    let titlesObj = [];

        this.selectedBillings.forEach(title => {
          titlesObj.push({
            NumeroDocumento: title.NumeroDocumento,
            Linha: title.Linha,
            AnoExercicio: title.AnoExercicio,
            Empresa: title.Empresa,
            ValorDocumento: title.ValorInterno
          });
        });

        const allowanceAutoObj = {
          Titulos: titlesObj,
          ContaClienteID: this.contaClienteID
        }

        this.bcAccountClientService.insertAllowanceProposal(allowanceAutoObj).subscribe(result => {
          if (result.Success) {
            this.result = true;
            this.close();
          } else {
            this.errorMessage = result.Errors;
          }
        }, error => {
          console.log(error);
        });

  }



	ngOnInit() {
    this.getReasonList();
    console.log("Titulos", this.selectedBillings)
	}

  getReasonList(){
    this.bcAccountClientService.getReasonList().subscribe(result => {
			if (result.Success) {
        this.reasonList = result.Result;
        console.log(this.reasonList);
			} else {
				console.log("Some error with reason list")
			}
		}, error => {
			console.log(error);
		});
  }

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-allowance-modal/bc-allowance-modal.component.ts